import {
  TRAVELCATEGORY_FETCHING,
  TRAVELCATEGORY_FAILED,
  TRAVELCATEGORY_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case TRAVELCATEGORY_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case TRAVELCATEGORY_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case TRAVELCATEGORY_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
